export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfCxc4AMP6lbBP.febf5ba0.woff2";